import { DASHBOARD_COMMUNITIES_PATH } from '@sly/core/constants/dashboardAppPaths';
import { PROVIDER_OD_ROLE } from '@sly/core/constants/roles';
import React from 'react';
import { assetPath } from 'sly/lib/path';
import { useAuth } from 'sly/services/auth';
import { Button } from 'sly/system';

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => {};

export default function ProviderClaimProfile() {
  const { user, ensureAuthenticated, authenticating } = useAuth();

  return (
    <a
      href='/providers'
      target='_blank'
      className='relative m-0 flex h-[416px] items-center gap-2.5 rounded-2xl md:m-4 md:h-[556px]'
    >
      <div
        className='absolute inset-0 z-10 hidden h-full w-full rounded-2xl bg-cover bg-center bg-no-repeat md:block'
        style={{
          backgroundImage: `url('${assetPath(
            'uploads/react-assets/providers/1e378dee8fae2e889fb47d51b0cd4cd7 (1).png'
          )}')`,
        }}
      />
      <div
        className='absolute inset-0 z-10 h-full w-full rounded-2xl bg-cover bg-center bg-no-repeat md:w-1/2'
        style={{
          backgroundImage: `url('${assetPath(
            'uploads/react-assets/providers/image 413 (5).png'
          )}')`,
        }}
      />

      <div className='relative z-20 mx-6 flex w-full flex-col items-start gap-8 rounded-2xl bg-white p-6 md:left-[10%] md:m-0 md:w-[502px] md:p-12'>
        <section className='flex flex-col items-start gap-4 self-stretch'>
          <p className='font-b-xs w-full font-bold tracking-widest text-viridian-base'>
            CLAIM YOUR FREE PROFILE
          </p>
          <h2 className='font-t-l'>
            Showcase your community to more than 5 million families
          </h2>
          <p className='font-b-m'>
            Manage information, ensure accuracy, and connect with potential
            residents.
          </p>
        </section>
        {!user ? (
          <Button
            disabled={authenticating}
            onClick={() =>
              ensureAuthenticated &&
              ensureAuthenticated(noop, 'provider', 'register')
            }
          >
            Claim my free profile
          </Button>
        ) : user?.roleID === PROVIDER_OD_ROLE ? (
          <Button variant='underlined' href={DASHBOARD_COMMUNITIES_PATH}>
            Go to dashboard
          </Button>
        ) : null}
      </div>
    </a>
  );
}
